import styled from 'styled-components'

export const ContainerButtons = styled.div`
  display: flex;
  flex-direction: row;
`

export const ModalAlertDueDateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 2rem;
  gap: 1rem;
`

export const ModalAlertDueDateInfo = styled.div`
  display: flex;
  align-items: start;
  justify-content: start;
  flex-direction: column;
  gap: 1rem;
`
